// extracted by mini-css-extract-plugin
export var actionButton = "_fo-0";
export var fileInput = "_fo-2";
export var paperclip = "_fo-1";